import MobileDetect from 'mobile-detect';

export const mobileDetect = new MobileDetect(navigator.userAgent);
